import React from 'react';
import { Stethoscope } from 'lucide-react';
import { PhysicianTable } from './PhysicianTable';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../shared/LibrarySection';
import { useNavigate } from 'react-router-dom';

export const PhysicianLibrarySection = {
	settingsView: 'physicians',
	title: 'Physicians',
	description: 'Manage physician directory and specialties',
	TitleIcon: Stethoscope
} satisfies SettingsSectionItem;

export function PhysicianLibrary() {
	const navigate = useNavigate();

	const handleAdd = () => {
		navigate('add');
	};

	return (
		<LibrarySection
			librarySection={PhysicianLibrarySection}
			handleAdd={handleAdd}
			addLabel="Add Physician"
			searchPlaceholder="Search physician by name, NPI, city, or address..."
			noResultsLabel="No Physicians Found"
			noResultsSubLabel="Get started by adding your first physician"
			TableComponent={PhysicianTable}
		/>
	);
}
